import api from '@/API';
import { Template } from '../types';

export default {
  create(accountId: string, name: string): Promise<Template> {
    return api.post(`accounts/${accountId}/templates`, { name });
  },
};
